import axios from "../../axiosInstance";

///commanUrl
const Billing_report = "ob/billing";
const ReportsbaseUrl = '/Reports';

class FundReport {
    getFundStatus(){
        return axios.get(Billing_report+'/getFundStatus')
    }
    getFundRefundReport(details){
        return axios.post(ReportsbaseUrl+'/getFundRefundReport',details)
    }
    getFundStatusReport(details){
        return axios.post(ReportsbaseUrl+'/getFundStatusReport',details)
    }
    Excelwrite(details) {
        return axios.post(ReportsbaseUrl + '/write', details)
    }
}
export default new FundReport();